const ClientRoutes = {
  Admin: {
    main: "/admin/main",
    todos: "/admin/todos",
    avivit: "/admin/avivit",
    news: "/admin/news",
    msg: "/admin/msg",
    guests: "/admin/guests",
  },
  Producer: {
    main: "/producer/main",
    todos: "/producer/todos",
  },
  Efrat: {
    main: "/efrat/main",
  },
  Tal: {
    main: "/tal/main",
  },
  User: {
    main: "/user/main",
    tables: "/user/tables",
    todos: "/user/todos",
    instruction: "/user/instruction",
    editDetails: "/user/editDetails",
  },
  UnAuth: {
    main: "/ua/main", // ua mean un auth
    invitation: "/n",
    selfInvitation: "/s",
    payment: "/payment",
  },
};

export default ClientRoutes;
